import Item from './Item';
import { SIZE_GROUND } from './Item';
import { NIGHT_TINT } from 'app/constants/AppConstants.js';

export default class Bucket extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.startX = 2600;
    this.startY = 590;

    this.locked = false;

    this.hitArea = new Phaser.Rectangle(-39, -80, 78, 80);

    this.asset = this.game.make.spine(0, 0, 'spine_bucket', true);
    this.asset.anchor.set(0.5, 1);
    this.addChild(this.asset);

    this.rootBone = this.asset.skeleton.getRootBone();

    this.asset.setAnimationByName(0, 'idle', false);
  }

  setLight(power) {
    // console.log('set light:', power);
    const r0 = 1;
    const g0 = 1;
    const b0 = 1;

    const tint = NIGHT_TINT;
    const r1 = (tint >> 16) / 255;
    const g1 = ((tint >> 8) & 0x00ff) / 255;
    const b1 = (tint & 0x0000ff) / 255;

    this.asset.skeleton.color.r = r1 + power * (r0 - r1);
    this.asset.skeleton.color.g = g1 + power * (g0 - g1);
    this.asset.skeleton.color.b = b1 + power * (b0 - b1);
  }

  handleInputDown(target, pointer) {
    if (!this.locked) {
      this.released = true;
      super.handleInputDown(target, pointer);
    }
  }

  handleInputUp() {
    if (!this.locked) {
      if (!this.released) {
        this.released = true;
      } else {
        super.handleInputUp();
      }
    }
  }

  update() {
    this.asset.update();
    super.update();
  }

  step(dt) {
    super.step(dt);

    if (this.drag && this.pointer && this.location.campfire.isLit) {
      const destX = this.location.campfire.x + 80;
      const destY = this.location.campfire.y - 150;
      const dx = this.x - destX;
      const dy = this.y - destY;

      if (dx < 0 && dx > -120 && dy < 120 && dy > 0) {
        this.snapToPosition(destX, destY, 300);
      }
    }
  }

  snapToPosition(x, y, time) {
    this.locked = true;
    this.released = false;

    this.location.stopDragItem(this);
    this.drag = false;
    this.updateBounds();

    this.scale.set(SIZE_GROUND);

    this.pointer = null;

    //
    this.dz = this.location.campfire.y - y;
    this.game.add
      .tween(this)
      .to({ x: x, y: y }, time, Phaser.Easing.Sinusoidal.Out, true)
      .onComplete.addOnce(this.pourWater, this);
  }

  pourWater() {
    this.asset.onComplete.addOnce(this.returnToStart, this);
    this.asset.setAnimationByName(0, 'pour', false);

    this.game.time.events.add(500, this.extinguish, this);
  }

  extinguish() {
    this.location.campfire.extinguish();
  }

  returnToStart() {
    this.asset.setAnimationByName(0, 'idle', false);
    this.game.add
      .tween(this)
      .to({ x: this.startX, y: this.startY }, 300, Phaser.Easing.Sinusoidal.Out, true)
      .onComplete.addOnce(this.handleReturn, this);
  }

  handleReturn() {
    this.locked = false;
    this.onChange.dispatch();
  }

  pulse(time = 1500) {
    const s0 = 0.8;
    const s1 = 1.3;
    const tween1 = this.game.add
      .tween(this.rootBone)
      .to({ scaleX: [s1, s0, s1, s0, s1, s0, 1], scaleY: [s0, s1, s0, s1, s0, s1, 1] }, time, null);
    const tween2 = this.game.add
      .tween(this.rootBone)
      .to(
        { scaleX: [s1, s0, s1, s0, s1, s0, 1], scaleY: [s0, s1, s0, s1, s0, s1, 1] },
        time,
        null,
        false,
        200
      );
    tween1.chain(tween2);
    tween1.start();
  }
}
